import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from '../../i18n/useTranslation';
import './LanguageSwitcher.css';

const LanguageSwitcher = ({ mobile }) => {
  const { lang, switchLanguage, availableLanguages } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const current = availableLanguages.find(l => l.code === lang);

  // Закрытие при клике вне
  useEffect(() => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  // Мобильная версия — три кнопки в ряд
  if (mobile) {
    return (
      <div className="lang-mobile">
        {availableLanguages.map(l => (
          <button
            key={l.code}
            className={`lang-mobile__btn ${lang === l.code ? 'lang-mobile__btn--active' : ''}`}
            onClick={() => switchLanguage(l.code)}
          >
            {l.flag} {l.name}
          </button>
        ))}
      </div>
    );
  }

  // Десктопная версия — выпадающий список
  return (
    <div className="lang-switcher" ref={ref}>
      <button
        className="lang-switcher__current"
        onClick={() => setOpen(!open)}
        aria-label="Switch language"
      >
        <span className="lang-switcher__flag">{current?.flag}</span>
        <span className="lang-switcher__code">{lang.toUpperCase()}</span>
        <span className={`lang-switcher__arrow ${open ? 'lang-switcher__arrow--open' : ''}`}>
          ▾
        </span>
      </button>

      {open && (
        <div className="lang-switcher__dropdown">
          {availableLanguages.map(l => (
            <button
              key={l.code}
              className={`lang-switcher__option ${lang === l.code ? 'lang-switcher__option--active' : ''}`}
              onClick={() => {
                switchLanguage(l.code);
                setOpen(false);
              }}
            >
              <span>{l.flag}</span>
              <span>{l.name}</span>
              {lang === l.code && <span className="lang-switcher__check">✓</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;